import LinkedScientificResearchSection from "./LinkedScientificResearchSection";

export default LinkedScientificResearchSection;
